import { createContainer } from 'react-sweet-state';

import {
  type Actions,
  PRIVATE_ACTIONS,
  ReadonlyDocumentScoresStore,
  type State,
} from './ReadonlyDocumentScoresStore';

export const ReadonlyDocumentScoresStoreContainer = createContainer<State, Actions>(
  ReadonlyDocumentScoresStore,
  {
    onInit:
      () =>
      ({ dispatch }) => {
        dispatch(PRIVATE_ACTIONS.init());
      },
  }
);
